var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.s.partnerWrap},[_c('div',{class:_vm.s.topImgs},_vm._l((_vm.topImgs),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0),_c('div',{class:_vm.s.companyImgs},_vm._l((_vm.companyImgs),function(item,index){return _c('img',{key:index,attrs:{"src":item,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }